import {
  ADD_NOTIFICATION,
  DISMISS_NOTIFICATION,
  REMOVE_ALL_CONTEXTUAL_NOTIFICATIONS,
  AddNotificationPayload,
  NotificationActionTypes,
  NotificationContext,
  ADD_SESSION_EXP_NOTIFICATION,
} from "./notification.types";

export interface Notification extends AddNotificationPayload {
  id: string;
  context: NotificationContext;
}

export interface NotificationState {
  list: Notification[];
}

const initialState: NotificationState = {
  list: [],
};

export const reducer = (
  state = initialState,
  action: NotificationActionTypes
) => {
  switch (action.type) {
    case ADD_NOTIFICATION: {
      const notification: Notification = {
        context: NotificationContext.Contextual,
        ...action.payload,
      };

      return {
        ...state,
        list: [...state.list, notification],
      };
    }
    case ADD_SESSION_EXP_NOTIFICATION: {
      const notification: Notification = {
        context: NotificationContext.Contextual,
        ...action.payload,
      };

      return { ...state, list: [notification] };
    }
    case DISMISS_NOTIFICATION: {
      const id = action.payload;

      return {
        ...state,
        list: state.list.filter((notification) => notification.id !== id),
      };
    }
    case REMOVE_ALL_CONTEXTUAL_NOTIFICATIONS: {
      return {
        ...state,
        list: state.list.filter(
          ({ context }) => context !== NotificationContext.Contextual
        ),
      };
    }
    default:
      return state;
  }
};
